import React from "react";

const LandingPageCard = ({
  title = "MRCP Part 1",
  description = "Over 4,900 Single Best Answer questions. Also includes the innovative Knowledge Tutor which tests you on thousands of high-yield facts",
  imageUrl = "https://placehold.co/100",
  primaryButtonText = "Take a demo",
  secondaryButtonText = "Sign up",
}) => {
  const styles = {
    card: {
      Width: "30%",
      backgroundColor: "white",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      border: "1px solid #e0e0e0",
      fontFamily: "Arial, sans-serif",
    },
    imageContainer: {
      backgroundColor: "#fff0f3",
      width: "100%",
    },
    image: {
      width: "100%",
      display: "block",
    },
    contentSection: {
      padding: "16px",
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "8px",
      marginTop: "0",
    },
    description: {
      fontSize: "14px",
      color: "#444",
      lineHeight: "1.4",
      marginBottom: "16px",
    },
    buttonContainer: {
      display: "flex",
      gap: "8px",
    },
    primaryButton: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#3b82f6",
      backgroundColor: "transparent",
      border: "1px solid #3b82f6",
      borderRadius: "4px",
      cursor: "pointer",
    },
    secondaryButton: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#16a34a",
      backgroundColor: "transparent",
      border: "1px solid #16a34a",
      borderRadius: "4px",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.card}>
      {/* ECG Image */}
      <div style={styles.imageContainer}>
        <img src={imageUrl} alt="ECG Waveform" style={styles.image} />
      </div>

      {/* Content Section */}
      <div style={styles.contentSection}>
        {/* Title */}
        <h2 style={styles.title}>{title}</h2>

        {/* Description */}
        <p style={styles.description}>{description}</p>

        {/* Buttons */}
        <div style={styles.buttonContainer}>
          <button style={styles.primaryButton}>{primaryButtonText}</button>
          <button style={styles.secondaryButton}>{secondaryButtonText}</button>
        </div>
      </div>
    </div>
  );
};

export default LandingPageCard;
